!<template>
    <div class="router-header flex flex-wrap items-center">
        <div class="content-area__heading">
            <router-link :to="{name : 'ErrorLogs'}">
                <vs-button radius  class="float-left mr-2" type="border" icon-pack="feather" icon="icon-arrow-left"></vs-button>
            </router-link>
            
            <span class="font">Error/Bug Log Details</span>
        </div>
        <!-- <div class="ml-auto md:block">
            <vs-button color="danger" icon-pack="feather">Deactivate</vs-button>
        </div> -->
        <vx-card class="mt-4" >
			<vs-row vs-type="flex">
                        <vs-col vs-order="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 1 / order 3 -->
                        </vs-col>
                        <vs-col vs-order="1"  vs-justify="center" vs-align="center" vs-w="2">
                                <p><b>Id :</b></p>
                        </vs-col>
                        <vs-col vs-order="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 3 / order 4 -->
                        </vs-col>
                        <vs-col vs-order="2"  vs-justify="center" vs-align="center" vs-w="4">
                                <p>{{ users[0].bug_id }}</p>
                        </vs-col>
            </vs-row>
            <vs-row vs-type="flex">
                        <vs-col vs-order="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 1 / order 3 -->
                        </vs-col>
                        <vs-col vs-order="1"  vs-justify="center" vs-align="center" vs-w="2">
                                <p><b>Date :</b></p>
                        </vs-col>
                        <vs-col vs-order="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 3 / order 4 -->
                        </vs-col>
                        <vs-col vs-order="2"  vs-justify="center" vs-align="center" vs-w="4">
                                <p>{{ users[0].date }}</p>
                        </vs-col>
            </vs-row>
           <vs-row vs-type="flex">
                        <vs-col vs-order="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 1 / order 3 -->
                        </vs-col>
                        <vs-col vs-order="1"  vs-justify="center" vs-align="center" vs-w="2">
                                <p><b>Time :</b></p>
                        </vs-col>
                        <vs-col vs-order="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 3 / order 4 -->
                        </vs-col>
                        <vs-col vs-order="2"  vs-justify="center" vs-align="center" vs-w="4">
                                <p>{{ users[0].time }}</p>
                        </vs-col>
            </vs-row>
            <vs-row vs-type="flex">
                        <vs-col vs-order="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 1 / order 3 -->
                        </vs-col>
                        <vs-col vs-order="1"  vs-justify="center" vs-align="center" vs-w="2">
                                <p><b>OS Type :</b></p>
                        </vs-col>
                        <vs-col vs-order="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 3 / order 4 -->
                        </vs-col>
                        <vs-col vs-order="2"  vs-justify="center" vs-align="center" vs-w="4">
                                <p>{{ users[0].os_type }}</p>
                        </vs-col>
            </vs-row>
            <vs-row vs-type="flex">
                        <vs-col vs-order="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 1 / order 3 -->
                        </vs-col>
                        <vs-col vs-order="1"  vs-justify="center" vs-align="center" vs-w="2">
                                <p><b>App Version :</b></p>
                        </vs-col>
                        <vs-col vs-order="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 3 / order 4 -->
                        </vs-col>
                        <vs-col vs-order="2"  vs-justify="center" vs-align="center" vs-w="4">
                                <p>{{ users[0].app_version }}</p>
                        </vs-col>
            </vs-row>
            <vs-row vs-type="flex">
                        <vs-col vs-order="3" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 1 / order 3 -->
                        </vs-col>
                        <vs-col vs-order="1"  vs-justify="center" vs-align="center" vs-w="2">
                                <p><b>Description :</b></p>
                        </vs-col>
                        <vs-col vs-order="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                <!-- 3 / order 4 -->
                        </vs-col>
                        <vs-col vs-order="2"  vs-justify="center" vs-align="center" vs-w="4">
                                <p>{{ users[0].description }}</p>
                        </vs-col>
            </vs-row>
		</vx-card>
    </div>
       
</template>

<script>
    export default {
        data :()=>({
            users: [
				{
					"id": 1,
					"bug_id": "6d38d898-5ede-43b8-9dc7-504ffc2858e1",
					"date": "2021/04/27",
					"time": "16:24",
					"os_type": "android",
                                        "app_version":"0.0.1",
                                        "description":"----"
				},
                
			],
        })
    }
</script>

<style lang="scss" scoped>

</style>